<template>
  <authenticated-layout>
    <div class="row">
      <div class="col-12">
        <usuarios-table />
      </div>
    </div>
  </authenticated-layout>
</template>

<script>
import AuthenticatedLayout from "@/components/AuthenticatedLayout.vue";
import UsuariosTable from "./components/UsuariosTable.vue";

export default {
  name: "Usuarios",
  components: {
    AuthenticatedLayout,
    UsuariosTable,
  },
};
</script>
